import * as React from 'react';

import { Access } from './parts/access';
import { AccessDeniedToPage } from '../containers/access-denied/accessDeniedToPage';
import { StandardPage } from './parts/standardPage';
import Enrollment from '../containers/enrollment';
import { useFeatureTogglesContext } from '../context/featureToggles';

export function EnrollmentRoute() {
  const featureToggles = useFeatureTogglesContext();

  if (featureToggles.hideEnrollmentPage) {
    return (
      <StandardPage>
        <AccessDeniedToPage />
      </StandardPage>
    );
  }

  return (
    <Access role="manager">
      <StandardPage>
        <Enrollment />
      </StandardPage>
    </Access>
  );
}
